<script>
	import { onMount, setContext } from 'svelte';
	import { mapbox, key } from './mapbox.js';

	export let lat;
	export let lon;
	export let zoom;

	let container;
	let map;
  
  setContext(key, {
		getMap: () => map
	});

	onMount(() => {
		map = new mapbox.Map({
			container,
			style: 'mapbox://styles/mapbox/streets-v11',
			center: [lon, lat],
			zoom,
      dragRotate: false,
      attributionControl: false
		}).addControl(new mapbox.AttributionControl({
      customAttribution: '<a href="https://www.riscognition.com/imprint.html" target="_blank"><strong>© Riscognition GmbH</strong></a>'
    }));

    const layerList = document.getElementById('menu');
    const inputs = layerList.getElementsByTagName('input');

    for (const input of inputs) {
      input.onclick = (layer) => {
        const layerId = layer.target.id;
        map.setStyle('mapbox://styles/mapbox/' + layerId);
      };
    }

    if (window.innerWidth > 768) {
      map.addControl(new MapboxGeocoder({
      accessToken: mapbox.accessToken,
      mapboxgl: mapbox,
      collapsed: false
      }), 'bottom-right');
    } else {
      map.addControl(new MapboxGeocoder({
      accessToken: mapbox.accessToken,
      mapboxgl: mapbox,
      collapsed: true
      }), 'bottom-right');
    }


    map.addControl(new mapbox.NavigationControl(), 'top-left');
		map.addControl(new mapbox.ScaleControl(), 'bottom-right');

    map.on('style.load', function() {
      map.addSource('nuts', {
      type: 'geojson',
      data:{
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Polygon',
              coordinates: []
            }
          }
    }); 
    map.addLayer({
          id: 'nutsPoly',
          type: 'line',
          source: 'nuts',
          paint: {
            'line-color': 'red',
            'line-width': 4,
          }
        });
    })

  });

</script>

<div id="map" bind:this={container}>
	{#if map}
		<slot></slot>
	{/if}
</div>

<div id="menu">
  <div id="basemap">
    <input id="streets-v11" type="radio" name="rtoggle" value="streets" checked="checked">
    <label for="streets-v11"> OSM</label>
  </div>
  <div id="basemap">
    <input id="satellite-v9" type="radio" name="rtoggle" value="satellite">
    <label for="satellite-v9"> Satellite</label>
  </div>
  <div id="basemap">
    <input id="light-v10" type="radio" name="rtoggle" value="light">
    <label for="light-v10">Light</label>
  </div>
  <div id="basemap">
    <input id="dark-v10" type="radio" name="rtoggle" value="dark">
    <label for="dark-v10">Dark</label>
  </div>
</div>

<style>
  #menu {
    position: absolute;
    width: 60px;
    height:105px;
    top: 10px;
    right: 10px;
    border-radius: 4px;
    background: #f4f4f4;
    border: 1px solid #cccccc;
    box-shadow: 1px 1px #dbdbdb;
    padding: 15px;
    font-family: Calibri Light, sans-serif;
    font-weight: bold;
    font-size: 13px;
  }
  #basemap {
    height: 30px;
    display: flex;
  }
  input {
     margin-right : 5px;
  }
  #map {
		width: 100%;
		height: 100%;
    position: relative;
	}
</style>